module.exports = __webpack_public_path__ + "static/media/DontIcon.b4f536a6.svg";